import { all, call, put, takeLatest } from '@redux-saga/core/effects';
import axios, { AxiosResponse } from 'axios';

import { SagaPayload } from '../api.types';
import { LoginRequest, LoginResponse } from './login.types';

import { LOGGING_IN } from './login.constants';

import { requestLogin } from './login.actions';

import { getLoginRequest } from './login.endpoints';

import { addSpinner, addSystemNotice, removeSpinner } from '../../slices/system/system.slice';

import { getErrorMessage } from '../../utils/api.util';
import { ERROR } from '../../utils/constants';
import { saveToLocalStorage } from '../../utils/util';

export function* performLoginRequest({ payload }: SagaPayload<LoginRequest>) {
  const { requestData, onSuccess } = payload;

  try {
    yield put(addSpinner(LOGGING_IN));

    const [endpoint, options] = getLoginRequest(requestData);

    const { data }: AxiosResponse<LoginResponse> = yield call(axios, endpoint, options);
    const { user, token } = data;

    if (!requestData.deleteAccount && user.role !== 'admin') {
      yield put(
        addSystemNotice({
          type: ERROR,
          message:
            'You do not have the required permissions to access this application from your web browser.' +
            ' Please attempt to log in from the Mobile App instead.'
        })
      );
      return;
    }

    yield call(saveToLocalStorage, 'token', token);
    yield call(saveToLocalStorage, 'user', user.userExternalReference);

    if (onSuccess) {
      yield call(onSuccess, undefined);
    }
  } catch (error) {
    const message = getErrorMessage(error);
    yield put(addSystemNotice({ type: ERROR, message }));
  } finally {
    yield put(removeSpinner(LOGGING_IN));
  }
}

export function* watchForLoginRequest() {
  yield takeLatest(requestLogin.type, performLoginRequest);
}

export default function* loginSaga() {
  yield all([watchForLoginRequest()]);
}
